import classNames from 'classnames'

import type { LinkType } from 'types'
import Menu from '../Menu'
import MenuItem from '../MenuItem'
import Ruler from '../../00-Primitives/Ruler'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'

import style from './style.scss'

type Props = {
  className?: string
  hasHeadline?: boolean
  links: LinkType[]
  title?: string // TODO this should be required
}

TabMenu.defaultProps = {
  className: '',
  hasHeadline: true, // TODO integrate with CMS so this is not defaulted to true
}

function TabMenu(props: Props) {
  const { className, hasHeadline, links, title } = props

  return (
    <div className={classNames(style.wrapper, className)}>
      {hasHeadline && title && (
        <>
          <Ruler className={style.ruler} />
          <HeadlineTwo className={style.title}>{title}</HeadlineTwo>
        </>
      )}
      <Menu
        aria-label={title || 'Tab menu'}
        className={style.menuWrapper}
        style={style}
      >
        {links.map(({ text, url }, index) => (
          <MenuItem
            key={`${text}-${index}`}
            style={style}
            text={text}
            url={url}
          />
        ))}
      </Menu>
    </div>
  )
}

export default TabMenu
